module.exports = "<app-img-docuware [docuwareID]=\"docuwareID\" displayMode=\"true\"></app-img-docuware>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/get-image/get-image.component.html
// module id = ./src/app/components/get-image/get-image.component.html
// module chunks = main